// extracted by mini-css-extract-plugin
export default {"container":"fVsxUwqk79JRun0DhmIq"};